/* eslint-disable no-unused-vars */
import React from 'react'
import { ButtonColor, ButtonType } from '../../../types'
import styles from '../SAPPCalendar.module.css'

interface IButtonProps {
  type?: ButtonType
  color?: ButtonColor
  hoverColor?: ButtonColor
  onClick?: () => void
  children: any
}

const Button = ({
  type = 'button',
  color = 'default',
  onClick,
  children
}: IButtonProps) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`${styles.btn} ${styles[`btn-${color}`]}`}
    >
      {children}
    </button>
  )
}

export default Button
